<template>
    <div>
        <div class="contact">
            <p class="text-muted title uppercase">{{ $t('contact') }}</p>

            <p>
                {{ message.content.displayName }}

                <span v-if="vCard">
                    <br>
                    <span v-for="(t, k) in vCard.tel" :key="k">
                        <span v-for="(v, i) in t.value" :key="i">
                            {{ v }} <br>
                        </span>
                    </span>
                </span>
            </p>
        </div>
    </div>
</template>

<style scoped>
    p.title {
        font-size: 8px;
    }

    p {
        padding: 0;
        margin: 0;
    }

    .contact {
        width: 250px;
        background-color: white;
        border: lightgrey solid 1px;
        border-radius: 5px;
        color: black;
        padding: 20px;
    }
</style>

<script>
    export default {
        props: {
            message: Object,
            instanceId: String
        },

        mounted() {
            this.vCard = this.parse(this.message.content.vcard);
        },

        data() {
            return {
                vCard: null
            }
        },

        methods: {
            parse(input) {
                var Re1 = /^(version|fn|title|org):(.+)$/i;
                var Re2 = /^([^:;]+);([^:]+):(.+)$/;
                var ReKey = /item\d{1,2}\./;
                var fields = {};

                input.split(/\r\n|\r|\n/).forEach(function (line) {
                    var results, key;

                    if (Re1.test(line)) {
                        results = line.match(Re1);
                        key = results[1].toLowerCase();
                        fields[key] = results[2];
                    } else if (Re2.test(line)) {
                        results = line.match(Re2);
                        key = results[1].replace(ReKey, '').toLowerCase();

                        var meta = {};
                        results[2].split(';')
                            .map(function (p, i) {
                                var match = p.match(/([a-z]+)=(.*)/i);
                                if (match) {
                                    return [match[1], match[2]];
                                } else {
                                    return ["TYPE" + (i === 0 ? "" : i), p];
                                }
                            })
                            .forEach(function (p) {
                                meta[p[0]] = p[1];
                            });

                        if (!fields[key]) fields[key] = [];

                        fields[key].push({
                            meta: meta,
                            value: results[3].split(';')
                        })
                    }
                });

                return fields;
            }
        }
    }
</script>
